export default "Les aides pour les locaux professionnels TPE/PME : primes CEE BAT, Coup de pouce CVC tertiaire, prêts Bpifrance climat et suramortissement fiscal. Cumuls et accompagnement.";
